/**
 * @file プラン情報取得フック（軽量版）
 *
 * SigV4認証付きGETリクエストでプラン情報を取得し、AxiosResponseをそのまま返却する。
 * Recoilへの格納やエラーハンドリングは呼び出し元に委譲。
 */
import { AxiosResponse } from 'axios';
import { useCallback } from 'react';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { ApiUrl } from '@/utils/constants';
import api from '@/utils/api';
import { PlanInfoResponse } from '@/types/api/mypage/planInfo';

/** 対象APIのエンドポイント */
const url = ApiUrl.Read.PLAN_INFO;

/**
 * プラン情報を取得する軽量フック（AxiosResponseをそのまま返却）
 * @returns execute - SigV4認証付きGETリクエストを実行し、レスポンスを返却
 */
const useGetPlanInfo = () => {
  const execute = useCallback(async (): Promise<AxiosResponse<PlanInfoResponse>> => {
    const headers = await getSigV4HeadersForGet(url);
    return api.get(url, headers);
  }, []);

  return { execute };
};

export default useGetPlanInfo;
